import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { SiaParamsAndPatternsService } from './params-and-patterns.service';

@Injectable({
  providedIn: 'root',
})
export class SiaDepartmentOverlayService {
  #siaParamsAndPatternsService = inject(SiaParamsAndPatternsService);

  private _isVisible = new BehaviorSubject<boolean>(false);
  private _loadingText = new BehaviorSubject<string>('Changing department...');

  // Observable streams
  get isVisible$() {
    return this._isVisible.asObservable();
  }

  get loadingText$() {
    return this._loadingText.asObservable();
  }

  constructor() {
    // Subscribe to department changes
    this.#siaParamsAndPatternsService.departmentChanged$.subscribe(() => {
      this.showOverlay();
      // Auto-hide after a delay (you can customize this logic)
      timer(2000).subscribe(() => {
        this.hideOverlay();
      });
    });
  }

  showOverlay(text?: string) {
    if (text) {
      this._loadingText.next(text);
    }
    this._isVisible.next(true);
  }

  hideOverlay() {
    this._isVisible.next(false);
  }

  setLoadingText(text: string) {
    this._loadingText.next(text);
  }
}